<template>
    <div>
        <template v-if="messages.length > 0">
            <message-item v-for="message in messages" :message="message" :key="'msg_' + message.id"></message-item>
        </template>
    </div>
</template>

<script>
import Events from "../../events";
import MessageItem from "./MessageItem";
import MessageEmployeeField from "./MessageEmployeeField";

export default {
    name: "UserTextMessage",
    components:{
        MessageItem,
        MessageEmployeeField
    },
    data() {
        return {
            messages:[],
        }
    },
    mounted() {
        this.loadMessages();
        Events.addEventListener("reload-messages", this.loadMessages);
    },
    methods: {
        loadMessages(){
            axios.get("/api/messages/get/direct/").then(
                (pack) => this.loadedMessages(pack.data),
                (pack) => this.loadMessageFailure(pack),
            );
        },
        loadedMessages(response){
            if(response.success){
                this.messages = response.data;
            }
        },
        loadMessageFailure(pack){
            console.warn(pack);
        }
    }
}
</script>
<style scoped></style>
